<template>
  <div>
    <v-btn color="primary" @click="getData()" :loading="loading" small>ver lista</v-btn>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      :overlay="false"
      max-width="900px"
      transition="dialog-transition"
    >
      <v-card>
        <v-toolbar color="primary" dark class="subheading">
          {{titulo}}
          <v-spacer></v-spacer>
          <v-btn flat icon @click="dialog=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs6>
              <v-text-field
                v-model="search"
                label="Ingrese Numero de Documento para Verificar"
                mask="##########"
                :disabled="filtro"
              ></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-btn color="primary" @click="getData" v-if="!filtro">
                <v-icon left dark>search</v-icon>buscar
              </v-btn>
              <v-btn color="error" @click="clearData" v-else>
                <v-icon left dark>close</v-icon>limpiar
              </v-btn>
            </v-flex>

            <v-flex xs12>
              <h3 v-if="!filtro">CANTIDAD TOTAL DE MATRICULAS INHABILITADAS: {{totalItems}}</h3>

              <span
                class="caption"
              >La presente información tiene como fin proporcionar seguridad jurídica, evitando perjuicios por el uso inadecuado de credenciales de abogados</span>
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="headers"
            :items="fallecidos"
            :pagination.sync="pagination"
            :loading="loading"
            :rows-per-page-items="rowsperpageitems"
            :total-items="totalItems"
            rowsPerPageText="Cantidad de Registros por Pagina"
            noResultsText="No se encontraron registros que coincidan con los parametros de busqueda"
            noDataText="No hay resultados"
          >
            <template slot="items" slot-scope="props">
              <td>{{props.item.codigoNumeroRegistroRpa}}</td>
              <td>{{props.item.matricula}}</td>
              <td>{{props.item.primerApellido}}</td>
              <td>{{props.item.segundoApellido}}</td>
              <td>{{props.item.nombres}}</td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="dialog=false">CERRAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      titulo: "LISTA DE MATRICULAS INHABILITADAS POR FALLECIMIENTO",
      dialog: false,
      filtro: false,
      headers: [
        {
          text: "Numero RPA",
          aligin: "left",
          sortable: false
        },
        {
          text: "Matricula",
          aligin: "left",
          sortable: false
        },
        {
          text: "Paterno",
          aligin: "left",
          sortable: false
        },
        {
          text: "Materno",
          aligin: "left",
          sortable: false
        },
        {
          text: "Nombres",
          aligin: "left",
          sortable: false
        }
      ],
      fallecidos: [],
      loading: false,
      search: null,
      load: false,
      pagination: {
        page: 1,
        rowsPerPage: 25
      },
      rowsperpageitems: [25, 50, 100],
      totalItems: 0
    };
  },
  watch: {
    pagination: {
      handler() {
        if (this.load) {
          this.getData();
        }
      },
      deep: true
    }
  },
  methods: {
    getData() {
      var headers = {
        limit: this.pagination.rowsPerPage,
        page: this.pagination.page
      };
      if (this.search !== null && this.search !== "") {
        headers.query = this.search;
        this.filtro = true;
      }
      this.loading = true;
      this.load = false;
      this.fallecidos = [];
      this.$http
        .get(`${this.$apiUrl}publico/abogado-fallecido`, {
          params: headers
        })
        .then(response => {
          this.totalItems = response.data.data.total_count;
          this.fallecidos = response.data.data.items;
          this.loading = false;
          this.dialog = true;
          this.load = true;
          if(this.totalItems==0){
              this.$store.commit('setErrorColor','error')
              this.$store.commit("setError", 'Sin Resultados para la busqueda de fallecidos');
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    clearData() {
      this.search = null;
      this.filtro = false;
      this.pagination.page = 1;
      this.getData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Fallecidos.vue